/**
 * @module acng/games/widgets/invite
 * @todo implement more than one game
 * @todo implement more than one price
 */
import {remove, onClick, clear, createDiv, toggleClass, createImage, append, createSpan, addClass, removeClass, on, off, text} from '@acng/frontend-bounty';

type Amateur = import('acng/amateurPool/factory/Amateur').Amateur;
type GamesService = import('../factory/games').GamesService;
type GameState = import('../factory/game').State;

const CSS_DISABLED = 'disabled';
const CSS_OFFLINE = 'offline';
const CSS_OCCUPIED = 'occupied';
const CSS_WAIT = 'wait';
import {media} from 'acng/core/service/env';
import imageSrc from '../../../basic/img/games/logo-4score.png';
const name = 'onswGameInvite';
export default name;

export const inviteComponent: angular.IComponentOptions = {
  bindings: {
    amateur: '<',
  },
  transclude: true,
  controller: class implements angular.IController {
    static $inject = ['games', '$element', '$translate', '$transclude'];
    amateur: Amateur | undefined;
    $doCheck: () => void;
    $onDestroy: () => void;
    constructor(
      games: GamesService, //
      $element: JQLite,
      $translate: angular.translate.ITranslateService,
      $transclude: angular.ITranscludeFunction
    ) {
      let listener: EventListener | undefined;
      let amateurIsOnline = false;
      let previousAmateur: typeof this.amateur;
      const element = $element[0];
      /**
       * Call when amateur or online state changes.
       */
      const change = async (amateur: typeof this.amateur) => {
        DEBUG: console.debug('games/widgets/invite', {amateur});
        let state: GameState | undefined;
        clear(element);
        off(games, 'update', listener);
        removeClass(element, CSS_DISABLED, CSS_WAIT, CSS_OCCUPIED);
        previousAmateur = amateur;
        // the correct online state must be set to prevent infinite change loop
        amateurIsOnline = !toggleClass(
          element, //
          CSS_OFFLINE,
          !amateur?.isOnline()
        );
        if (!amateur?.hasGames()) {
          // either no amateur or amateur without games
          addClass(element, CSS_DISABLED);
          return;
        }
        const box = createDiv('box');
        const image = createImage(`${media.assets}/${imageSrc}`);
        const label = createSpan('label');
        const value = createSpan('value');
        const click = async () => {
          DEBUG: console.debug('games/widgets/invite click', {amateur});
          if (!state) {
            addClass(box, CSS_WAIT);
            off(box, 'click', click);
            await games.invite(amateur).catch(() => {
              removeClass(box, CSS_WAIT);
              on(box, 'click', click);
            });
          }
          location.hash = `/sedcard/${amateur.nickname}/game`;
        };
        /**
         * Call when game state changes.
         */
        const update = async () => {
          remove(value);
          remove(box);
          state = (await games.getRunningGame(amateur.id))?.getState();
          toggleClass(element, CSS_OCCUPIED, !!state);
          if (state) {
            if (state.userTurn) {
              text(label, await $translate('games.userTurn'));
            } else {
              text(label, await $translate('games.wait', {nickname: amateur.getNickname()}));
            }
          } else if (!amateurIsOnline) {
            text(label, await $translate('games.offline', {nickname: amateur.getNickname()}));
          } else {
            text(label, await $translate('games.invite'));
            text(value, '25 Coins');
            append(box, value);
          }
          removeClass(box, CSS_WAIT);
          onClick(box, click);
          append(element, box);
        };
        // Append elements to box which persist game state updates.
        append(box, image, label);
        $transclude(clone => clone?.appendTo(box));
        // Unnecessary game state updates do no harm
        on(games, 'update', update);
        await update();
      };
      // Trigger changes.
      this.$doCheck = () => {
        const currentAmateur = this.amateur;
        if (currentAmateur != previousAmateur) {
          DEBUG: console.debug('games/widgets/invite $doCheck amateur changed', {old: previousAmateur, new: currentAmateur});
          change(currentAmateur);
          return;
        }
        if (currentAmateur && currentAmateur.isOnline() != amateurIsOnline) {
          DEBUG: console.debug('games/widgets/invite $doCheck online state changed', {old: amateurIsOnline, new: currentAmateur.isOnline()});
          change(currentAmateur);
        }
      };
      // Remove possible EventListener.
      this.$onDestroy = () => off(games, 'update', listener);
    }
  },
};
